import { useEffect, useState } from "react";
import { useGetRenewalReasons } from "../api/v1";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";

export const useGetRenewalDeclineData = () => {
   const filterData = useDashboardFilterContext();
  const [renewalDeclineChartData, setRenewalDeclineChartData] = useState([]);
  const { renewalReasons, isLoading } = useGetRenewalReasons(filterData);

  useEffect(() => {
    if (renewalReasons?.length === 0) return;
    const data = renewalReasons?.map((record) => ({
      name: record?.reason,
      value: record?.count,
    }));

    setRenewalDeclineChartData(data);
  }, [renewalReasons]);

  return { renewalDeclineChartData, isLoading };
};
